
    
export default {

  props: {
    opacity: Number,
    zIndex: Number,
  }
}
